var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"error-message error--text"},[_c('v-icon',{staticClass:"error-message__icon",attrs:{"color":"error"}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]),_c('span',{staticClass:"error-message__text"},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.message)+" ")]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }